interface ResultsSummaryProps {
  count: number
  searchTerm: string
  onClearSearch: () => void
}

export default function ResultsSummary({ count, searchTerm, onClearSearch }: ResultsSummaryProps) {
  return (
    <div className="flex items-center justify-between text-sm text-slate-600 dark:text-slate-300 mb-4">
      <div className="flex items-center space-x-4">
        <span>
          Showing {count} opportunities
        </span>
      </div>
      {searchTerm && (
        <button
          onClick={onClearSearch}
          className="text-accent hover:text-accent/80"
        >
          Clear search
        </button>
      )}
    </div>
  )
}